export const journeyCopyFr = {
    profileCompleteTitle: "Profil complété",
    profileCompleteStatusLabel: "Profil enregistré",
    profileCompleteConsentDescription:
        "Les informations de votre profil ont été enregistrées. Nous allons maintenant passer au consentement.",
    profileCompleteSetupDescription:
        "Les informations de votre profil ont été enregistrées. Nous avons maintenant besoin des détails de votre traitement.",
    profileCompleteFormsDescription:
        "Les informations de votre profil ont été enregistrées. Vous pouvez maintenant remplir vos formulaires.",
    profileCompleteDiaryDescription: "Les informations de votre profil ont été enregistrées.",
    consentCompleteTitle: "Consentement terminé",
    consentCompleteStatusLabel: "Consentement signé",
    consentCompleteSetupDescription:
        "Merci ! Vos consentements ont été enregistrés. Nous avons encore besoin de quelques informations supplémentaires.",
    consentCompleteFormsDescription:
        "Vos consentements ont été enregistrés. Vous pouvez maintenant remplir vos formulaires.",
    consentCompleteDiaryDescription: "Vos consentements ont été enregistrés.",
    setupCompleteTitle: "Configuration terminée",
    setupCompleteStatusLabel: "Configuration enregistrée",
    setupCompleteConsentDescription: "Nous allons maintenant passer au consentement.",
    setupCompleteFormsDescription:
        "Merci ! Vos informations ont été enregistrées. Nous avons encore besoin de quelques informations supplémentaires.",
    setupCompleteDiaryDescription: "Les détails de votre traitement sont prêts.",
    formCompleteTitle: "Formulaire terminé",
    formCompleteNextDescription: "Votre réponse a été enregistrée. Vous pouvez passer à la saisie suivante.",
    formCompleteAllDoneDescription:
        "Votre réponse a été enregistrée. Vous êtes à jour pour le moment. Vous pouvez consulter vos résultats.",
    formCompleteNextEntryDue: (scheduleLabel, date) =>
        `Votre saisie « ${scheduleLabel.toLowerCase()} » est à effectuer le ${date}.`,
    formCompleteStatusSuffix: "terminé",
    continueToNextForm: "Suivant",
    goToConsent: "Aller au consentement",
    goToSetup: "Aller à la configuration",
    knowProcedureDateYetTitle: "Connaissez-vous déjà la date ?",
    knowProcedureDateYetMessage:
        "Ajoutez la date de votre intervention dès que vous la connaissez afin que les questions de suivi correspondent à votre traitement.",
    addProcedureDate: "Ajouter la date de l'intervention",
    addHospitalNumber: "Ajouter le numéro de dossier hospitalier",
    addSide: "Ajouter le côté",
    addEventDate: (eventPhrase) => `Ajouter la date (${eventPhrase})`,
    reviewConsent: "Lire le consentement",
    shortcutsHeading: "Reste à faire :",
    goToForms: "Aller aux formulaires",
    goToYourDiary: "Aller à votre journal",
    goToYourResults: "Aller à vos résultats",
    phaseProfile: "Profil",
    phaseSetup: "Configuration",
    phaseConsent: "Consentement",
    phaseForms: "Formulaires",
    phaseDiary: "Journal",
    setupHospitalNumber: "Numéro de dossier hospitalier",
    setupProcedureDate: "Date de l'intervention",
    setupSide: "Côté",
    loadingProgress: "Chargement de la progression...",
    progressTitle: "Votre progression",
    dismissProgress: "Fermer la progression",
    currentStage: "Étape actuelle",
    stepProgressAriaLabel: (stepLabel) => `Progression : ${stepLabel}`,
    stepOf: "sur",
    nextStep: "Prochaine étape",
    formsDoneCount: (done, total) => `Formulaires remplis : ${done} sur ${total}`,
    diaryStillSettingUp: "Votre journal est encore en cours de création. Cela peut prendre un moment.",
    tryAgain: "Réessayer",
};
